import React from 'react';
import PageCharacterLink from './PageCharacterLink';
import { translate } from '../../translations/translator';
import { remCalc } from '../../util/style-util';
import { darkGray } from '../../styles/style-constants';
import { makeStyles } from '@mui/styles';
const translateBookMenus = key => translate('bookMenus', key);

type Props = {
  characters: { [key: string]: any }[];
  color: string;
  closeMenu: () => void;
  type: string;
  section: any;
  name: string;
};

const useStyles = makeStyles(() => ({
  groupCharacters: {
    listStyle: 'none',
    paddingLeft: 0,
    gridArea: 'main',
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'row wrap',
    width: remCalc(240),
    margin: 'auto',
    marginTop: remCalc(24),
    color: darkGray
  },
  instructions: {
    marginBottom: remCalc(32)
  }
}));

const CharacterMenuGroup = ({ characters, color, type, closeMenu }: Props) => {
  const classes = useStyles();
  return (
    <section className={classes.groupCharacters}>
      <div className={classes.instructions}>
        {type === '123' ? translateBookMenus('selectNumber') : translateBookMenus('selectLetter')}
      </div>
      <div>
        {characters?.map((symbol: any, i) => (
          <PageCharacterLink
            key={`${symbol.character} - ${i}`}
            symbol={symbol}
            color={color}
            closeMenu={closeMenu}
            noLeftSpacing={false}
            useFlex={true}
            hasIcon={false}
          />
        ))}
      </div>
    </section>
  );
};

export default CharacterMenuGroup;
